module.exports = __webpack_public_path__ + "img/profile.06bd16fc.jpg";